<script>
  import { onDestroy } from 'svelte';
  import { Search, X } from 'lucide-svelte';

  export let placeholder = 'Tìm cuộc trò chuyện';
  export let autoFocus = false;
  export let debounce = 180;
  export let onSearch = () => {};
  export let onClear = () => {};

  let value = '';
  let timer;

  function emitSearch(nextValue) {
    clearTimeout(timer);
    timer = setTimeout(() => onSearch(nextValue.trim()), debounce);
  }

  function handleInput(event) {
    value = event.currentTarget.value;
    emitSearch(value);
  }

  function clear() {
    value = '';
    clearTimeout(timer);
    onClear();
    onSearch('');
  }

  function handleKeydown(event) {
    if (event.key === 'Escape' && value) clear();
  }

  onDestroy(() => clearTimeout(timer));
</script>

<label class="conversation-search">
  <Search size={17} />
  <input
    type="search"
    bind:value
    {placeholder}
    autofocus={autoFocus}
    autocomplete="off"
    enterkeyhint="search"
    oninput={handleInput}
    onkeydown={handleKeydown} />

  {#if value}
    <button type="button" aria-label="Xóa tìm kiếm" title="Xóa tìm kiếm" onclick={clear}>
      <X size={15} />
    </button>
  {/if}
</label>

<style>
  .conversation-search {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    width: 100%;
    min-width: 0;
    height: 2.55rem;
    padding: 0 0.75rem;
    border: 1px solid rgba(148, 163, 184, 0.18);
    border-radius: 999px;
    color: #64748b;
    background: rgba(241, 245, 249, 0.82);
    transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
  }

  .conversation-search:focus-within {
    border-color: rgba(14, 165, 233, 0.42);
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
  }

  input {
    flex: 1;
    min-width: 0;
    width: 100%;
    color: #0f172a;
    background: transparent;
    outline: none;
    font-size: 0.78rem;
  }

  input::-webkit-search-cancel-button {
    display: none;
  }

  button {
    display: grid;
    flex: 0 0 auto;
    place-items: center;
    width: 1.65rem;
    height: 1.65rem;
    border-radius: 999px;
    color: #64748b;
    background: rgba(148, 163, 184, 0.12);
  }
</style>
